import { FC, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "@/utils/store";

import FiltersDropdown from "@/components/FilterDropdown";
import FilterButton from "@/components/FilterDropdown/FilterButton";
import FilterRadioButton from "@/components/FilterDropdown/FilterRadioButton";
import {
  FilterGroupBody,
  FilterGroupHeader,
  FilterGroupTitle,
  FilterWrap,
} from "@/components/FilterDropdown/Parts";

const StyledFiltersDropdown = styled(FiltersDropdown)`
  max-height: 336px;
  width: 220px;
`;

interface Props {
  activeTeam: string;
  setActiveTeam: React.Dispatch<React.SetStateAction<string>>;
}

const ProjectsTeamFilter: FC<Props> = ({ activeTeam, setActiveTeam }) => {
  const [showFilters, setShowFilters] = useState(false);

  const teams = useSelector((state: RootState) => state.teams);

  const teamIds = Object.keys(teams).filter((id) => !isNaN(Number(id)));

  return (
    <FilterWrap>
      <FilterButton
        text="Team"
        isActive={showFilters}
        onClick={(e) => {
          e?.stopPropagation();
          setShowFilters((prev) => !prev);
        }}
        filterApplied
      />
      {showFilters && (
        <StyledFiltersDropdown onClose={() => setShowFilters(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>Team:</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            <FilterRadioButton
              id={`teamRadio`}
              value=""
              checked={!activeTeam}
              setValue={(newValue) => setActiveTeam(newValue)}
            >
              All Teams
            </FilterRadioButton>
            {teamIds.map((teamId, index) => (
              <FilterRadioButton
                key={index}
                id={`teamRadio${index}`}
                value={teamId}
                checked={activeTeam === teamId}
                setValue={(newValue) => setActiveTeam(newValue)}
              >
                {teams[teamId].name}
              </FilterRadioButton>
            ))}
          </FilterGroupBody>
        </StyledFiltersDropdown>
      )}
    </FilterWrap>
  );
};

export default ProjectsTeamFilter;
